import React from 'react';
import HeroSplit from '../components/sections/HeroSplit';
import FeaturesTiles from '../components/sections/FeaturesTiles';
import News from '../components/sections/News';
import Roadmap from '../components/sections/Roadmap';
import Pricing from '../components/sections/Pricing';
import SupportSplit from '../components/sections/SupportSplit';

class Home extends React.Component {
  render() {
    return (
      <React.Fragment>
        <HeroSplit id="home" hasBgColor invertColor />
        <FeaturesTiles />
        {/* <FeaturesTabs topDivider bottomOuterDivider /> */}
        <News id="tutorials" className="illustration-section-01" />
        <Roadmap topOuterDivider />
        <Pricing id="pricing" hasBgColor />
        <SupportSplit id="contact" topOuterDivider />
      </React.Fragment>
    );
  }
}

export default Home;